/* eslint-disable no-shadow */
import React, { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import { authContext } from 'contexts/AuthContext';
import { axiosDelete } from 'services';
import FSBModal from 'components/common/FSBModal';
import DeleteConfirmationAlert from 'components/DeleteConfirmationAlert';
import AddEditUploadPromoImage from '../AddEditUploadPromoImage';
import BannerList from './components/BannerList';

const CommonPromoBannerAndAdvt = () => {
  const { auth } = useContext(authContext);
  const [isOpen, setIsOpen] = useState({
    status: false,
    row: '',
    type: ADD_EDIT_CONSTANT.ADD,
    refetch: () => {},
  });
  const [showDeleteRecord, setDeleteRecord] = useState(false);
  const [deleteRow, setDeleteRow] = useState({ row: '', refetch: () => {} });

  const toggleDeleteRecord = (row, refetch = () => {}) => {
    setDeleteRow({ row, refetch });
    setDeleteRecord(!showDeleteRecord);
  };

  const onDeleteConfirmation = async () => {
    try {
      const resp = await axiosDelete(
        `${process.env.REACT_APP_REST_API_ENDPOINT}banner-position/${deleteRow?.row?.id}`,
        auth?.data?.token,
      );
      if (resp?.status === 'success') {
        toast.success('Banner deleted successfully');
        deleteRow?.refetch?.();
      } else {
        toast.error(resp?.message || 'Unable to delete banner');
      }
      setDeleteRecord(!showDeleteRecord);
    } catch (err) {
      toast.error(err);
    }
  };

  const drawerToggle = (row, type, refetch = () => {}) => {
    setIsOpen({ status: !isOpen.status, row, type, refetch });
  };

  return (
    <div>
      {isOpen.status && (
        <FSBModal
          open={isOpen.status}
          size="md"
          title={`${isOpen?.type === ADD_EDIT_CONSTANT.EDIT ? 'Edit' : 'Add'} New`}
          closeButtonLabel=""
          confirmButtonLabel=""
          message=""
          toggleAlert={drawerToggle}
          onClose={drawerToggle}
          onConfirmClick={drawerToggle}
        >
          <AddEditUploadPromoImage
            drawerToggle={drawerToggle}
            type={isOpen?.type}
            row={isOpen?.row}
            refetch={isOpen?.refetch}
          />
        </FSBModal>
      )}
      <div className="banner-wrap-min-h position-relative">
        <h6 className="mt-2 mb-0 f-16 fw-semibold mb-3">Banner</h6>
        <BannerList
          toggleDeleteRecord={toggleDeleteRecord}
          drawerToggle={drawerToggle}
        />
      </div>
      <DeleteConfirmationAlert
        open={showDeleteRecord}
        title="Delete"
        message="Do you really want to remove this Image?"
        cancelButtonLabel="Close"
        addButtonLabel="Delete"
        onConfirm={onDeleteConfirmation}
        onCancel={toggleDeleteRecord}
      />
    </div>
  );
};

export default CommonPromoBannerAndAdvt;
